import React, { useRef, useEffect } from 'react';
import ALink from 'tradera/components/alink/alink';
import { useUrlLocalizer } from 'tradera/lang/translate';
import { getCategoryIcon } from 'tradera/helpers/category-icon-helper';
import useIsMobile from 'tradera/hooks/use-is-mobile';
import { GtmService } from 'tradera/services/google-tagmanager-service';
import styles from './category-link.module.scss';

type CategoryLinkProps = {
    href: string;
    categoryId: number;
    title: string;
    width: number;
    setWidth: (width: number) => void;
};
export const CategoryLink = ({
    href,
    categoryId,
    title,
    width,
    setWidth
}: CategoryLinkProps) => {
    const { toLocalizedUrl } = useUrlLocalizer();
    const titleRef = useRef<HTMLSpanElement>(null);
    const isMobile = useIsMobile();

    useEffect(() => {
        // We need to set the width of the category link to the width of the title (locally: add 30% to it to compensate for the text-styled class).
        const w = Math.floor(titleRef.current?.clientWidth ?? 0);
        if (w > width) {
            setWidth(w);
        }
    }, [titleRef, width, setWidth]);

    const onClick = async () => {
        GtmService.trackAction('StartPage', 'CategoryLink', title);
    };

    return (
        <ALink
            style={{ width: width != 0 ? width : 'auto' }}
            className={`${styles.link} d-flex flex-column justify-content-center`}
            key={categoryId}
            onClick={onClick}
            href={toLocalizedUrl(href)}>
            <span className="m-1 text-center">
                {getCategoryIcon(
                    categoryId,
                    title,
                    isMobile ? styles.icon : 'icon-lg'
                )}
            </span>
            <span
                className="d-flex mx-auto text-styled text-nowrap size-dublin mb-2 mb-md-0"
                ref={titleRef}>
                {title}
            </span>
        </ALink>
    );
};
